<!--IKKE I BRUG-->
@if (loggedIn) {
  <div class="holder">
    <form>
      <fieldset [disabled]="isLoading">
        @if (type == "stretches" && state == "list") {
          <table class="maintable">
            <tr>
              <th style="width: 26.5%" (click)="sortTable('code')">
                {{ strings.artesStrings["CODE"] }}
              </th>
              <th style="width: 26.5%" (click)="sortTable('infrastructure')">
                {{ strings.artesStrings["SHORT_NAME"] }}
              </th>
              <th style="width: 26.5%" (click)="sortTable('full_name')">
                {{ strings.artesStrings["FULL_NAME"] }}
              </th>
              <th style="width: 10%"></th>
              <th class="btnholder" style="width: 10%">
                <button (click)="addNewObject('stretches')">
                  {{ strings.artesStrings["CREATE"] }}
                </button>
              </th>
            </tr>
            @for (
              stretch of $any(constantsService.constants.stretches);
              track stretch
            ) {
              <tbody>
                @if (!editMode || (editMode && editId !== stretch.id)) {
                  <tr>
                    <td>
                      <span>{{ stretch.code }}</span>
                    </td>
                    <td>
                      <span>{{ stretch.infrastructure }}</span>
                    </td>
                    <td>
                      <span>{{ stretch.full_name }}</span>
                    </td>
                    <td class="btnholder">
                      <button (click)="editMode = true; editId = stretch.id">
                        {{ strings.artesStrings["EDIT"] }}
                      </button>
                    </td>
                    <td class="btnholder">
                      <button (click)="deleteConstant('stretches', stretch)">
                        {{ strings.artesStrings["DELETE"] }}
                      </button>
                    </td>
                  </tr>
                }
                @if (editMode && editId === stretch.id) {
                  <tr>
                    <td>
                      <input
                        type="text"
                        name="stretch-code"
                        [(ngModel)]="stretch.code"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name="stretch-infrastructure"
                        [(ngModel)]="stretch.infrastructure"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name="stretch-fullname"
                        [(ngModel)]="stretch.full_name"
                      />
                    </td>
                    <td class="btnholder">
                      <button (click)="discardChanges()">
                        {{ strings.artesStrings["CANCEL"] }}
                      </button>
                    </td>
                    <td class="btnholder">
                      <button (click)="saveChanges('stretches', stretch)">
                        {{ strings.artesStrings["SAVE"] }}
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            }
          </table>
        }
      </fieldset>
    </form>
    <form>
      <fieldset [disabled]="isLoading">
        @if (type == "stations" && state == "list") {
          <table class="maintable">
            <tr>
              <th style="width: 26.5%" (click)="sortTable('code')">
                {{ strings.artesStrings["CODE"] }}
              </th>
              <th style="width: 26.5%" (click)="sortTable('station')">
                {{ strings.artesStrings["SHORT_NAME"] }}
              </th>
              <th style="width: 26.5%" (click)="sortTable('full_name')">
                {{ strings.artesStrings["FULL_NAME"] }}
              </th>
              <th style="width: 10%"></th>
              <th class="btnholder" style="width: 10%">
                <button (click)="addNewObject('stations')">
                  {{ strings.artesStrings["CREATE"] }}
                </button>
              </th>
            </tr>
            @for (
              station of constantsService.constants.stations;
              track station
            ) {
              <tbody>
                @if (!editMode || (editMode && editId !== station.id)) {
                  <tr>
                    <td>{{ station.code }}</td>
                    <td>{{ station.station }}</td>
                    <td>{{ station.full_name }}</td>
                    <td class="btnholder">
                      <button (click)="editMode = true; editId = station.id">
                        {{ strings.artesStrings["EDIT"] }}
                      </button>
                    </td>
                    <td class="btnholder">
                      <button (click)="deleteConstant('stations', station)">
                        {{ strings.artesStrings["DELETE"] }}
                      </button>
                    </td>
                  </tr>
                }
                @if (editMode && editId === station.id) {
                  <tr>
                    <td>
                      <input
                        type="text"
                        name="station-code"
                        [(ngModel)]="station.code"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name="station-station"
                        [(ngModel)]="station.station"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name="station-fullname"
                        [(ngModel)]="station.full_name"
                      />
                    </td>
                    <td class="btnholder">
                      <button (click)="saveChanges('stations', station)">
                        {{ strings.artesStrings["SAVE"] }}
                      </button>
                    </td>
                    <td class="btnholder">
                      <button (click)="discardChanges()">
                        {{ strings.artesStrings["CANCEL"] }}
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            }
          </table>
        }
      </fieldset>
    </form>
    <form>
      <fieldset [disabled]="isLoading">
        @if (type == "engines" && state == "list") {
          <table class="maintable">
            <tr>
              <th style="width: 80%" (click)="sortTable('engine')">
                {{ strings.artesStrings["NAME"] }}
              </th>
              <th style="width: 10%"></th>
              <th class="btnholder" style="width: 10%">
                <button (click)="addNewObject('engines')">
                  {{ strings.artesStrings["CREATE"] }}
                </button>
              </th>
            </tr>
            @for (engine of constantsService.constants.engines; track engine) {
              <tbody>
                @if (!editMode || (editMode && editId !== engine.id)) {
                  <tr>
                    <td>{{ engine.engine }}</td>
                    <td class="btnholder">
                      <button (click)="editMode = true; editId = engine.id">
                        {{ strings.artesStrings["EDIT"] }}
                      </button>
                    </td>
                    <td class="btnholder">
                      <button (click)="deleteConstant('engines', engine)">
                        {{ strings.artesStrings["DELETE"] }}
                      </button>
                    </td>
                  </tr>
                }
                @if (editMode && editId === engine.id) {
                  <tr>
                    <td>
                      <input
                        type="text"
                        name="engine-engine"
                        [(ngModel)]="engine.engine"
                      />
                    </td>
                    <td class="btnholder">
                      <button (click)="saveChanges('engines', engine)">
                        {{ strings.artesStrings["SAVE"] }}
                      </button>
                    </td>
                    <td class="btnholder">
                      <button (click)="discardChanges()">
                        {{ strings.artesStrings["CANCEL"] }}
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            }
          </table>
        }
      </fieldset>
    </form>
  </div>
}
